const countyIncomeLimitsData = Object.freeze({
  atlantic: [
    '$56,150',
    '$64,150',
    '$72,150',
    '$80,150',
    '$86,600',
    '$93,000',
    '$99,400',
    '$105,800',
  ],
  bergen: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  burlington: [
    '$66,850',
    '$76,400',
    '$85,950',
    '$95,500',
    '$103,150',
    '$110,800',
    '$118,450',
    '$126,100',
  ],
  camden: [
    '$66,850',
    '$76,400',
    '$85,950',
    '$95,500',
    '$103,150',
    '$110,800',
    '$118,450',
    '$126,100',
  ],
  'cape may': [
    '$67,550',
    '$77,200',
    '$86,850',
    '$96,500',
    '$104,250',
    '$111,950',
    '$119,700',
    '$127,400',
  ],
  cumberland: [
    '$51,950',
    '$59,350',
    '$66,750',
    '$74,150',
    '$80,100',
    '$86,050',
    '$91,950',
    '$97,900',
  ],
  essex: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  gloucester: [
    '$66,850',
    '$76,400',
    '$85,950',
    '$95,500',
    '$103,150',
    '$110,800',
    '$118,450',
    '$126,100',
  ],
  hudson: [
    '$75,050',
    '$85,800',
    '$96,500',
    '$107,200',
    '$115,800',
    '$124,400',
    '$132,950',
    '$141,550',
  ],
  hunterdon: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  mercer: [
    '$71,050',
    '$81,200',
    '$91,350',
    '$101,500',
    '$109,650',
    '$117,750',
    '$125,900',
    '$134,000',
  ],
  middlesex: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  monmouth: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  morris: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  ocean: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  passaic: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  salem: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  somerset: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  sussex: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  union: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  warren: [
    '$70,400',
    '$80,450',
    '$90,500',
    '$100,550',
    '$108,600',
    '$116,650',
    '$124,700',
    '$132,750',
  ],
});

export const njDefaultCounties = Object.freeze([
  'Atlantic County',
  'Bergen County',
  'Burlington County',
  'Camden County',
  'Cape may County',
  'Cumberland County',
  'Essex County',
  'Gloucester County',
  'Hudson County',
  'Hunterdon County',
  'Mercer County',
  'Middlesex County',
  'Monmouth County',
  'Morris County',
  'Ocean County',
  'Passaic County',
  'Salem County',
  'Somerset County',
  'Sussex County',
  'Union County',
  'Warren County',
]);

export const CountyIncomeLimits = (() => {
  return {
    getIncomeLimits: (countyName: string, occupancy: number) => {
      if (countyIncomeLimitsData[countyName]) {
        return countyIncomeLimitsData[countyName][occupancy];
      }
    },
  };
})();
